/*
    Requires product-card.liquid for styling.
    Requires global-helper.js for price conversion.
    Requires cart-helper.js for adding item to cart.
    Requires element-builder.js for building card.
*/

class ProductCard {

    constructor(product) {

        this.product = product;
        this.id = product.id;
        this.handle = product.handle;
        this.variants = product.variants;
        this.title = product.title;
        this.description = product.description;
        this.productID = product.id;
        this.image = product.image;
        this.sellingTags = product.selling_tags;
        this.highlightColor = product.highlight_color;
        this.shortDescription = product.short_description;
        this.whatYouGet = product.what_you_get;

        this.cartButtonText = "Add to cart";
        this.addingToCartMessage = "Adding";
        this.addedToCartMessage = "Added to cart!";
        this.failedToAddToCartMessage = "Failed to add.";
        this.addToCartMessageDelay = 1000;
        this.addingToCartAnimationSpeed = 200;

    }

    build() {

        const productCard = new ElementBuilder("div").withClass("product-card").build();
        const productLink = new ElementBuilder("a").withHref(`/products/${this.handle}`).build();

        productCard.appendChild(productLink);

        const imageWrapper = new ElementBuilder("div").withClass("product-card-image-wrapper").build();
    
        imageWrapper.appendChild(new ElementBuilder("img").withClass("product-card-image").withSrc(this.image.src).withAlt(this.image.alt).build());
        
        const sellingTagsWrapper = new ElementBuilder("div").withClass("product-card-selling-tags").build();

        this.sellingTags.forEach(tag => {

            sellingTagsWrapper.appendChild(new ElementBuilder("h4").withClass("product-card-selling-tag").withTextContent(tag.tag).build());

        });

        imageWrapper.appendChild(sellingTagsWrapper);

        productLink.appendChild(imageWrapper);

        productLink.appendChild(new ElementBuilder('div').withClass("product-card-color-highlight").withStyle(new ElementStyleBuilder().withProperty("backgroundColor", this.highlightColor)).build());

        const mainContentArea = new ElementBuilder("div").withClass("product-card-main-content-wrapper").build();

        mainContentArea.appendChild(new ElementBuilder("h4").withClass("product-card-short-description").withTextContent(this.shortDescription).build());
        mainContentArea.appendChild(new ElementBuilder("h2").withClass("product-card-title").withTextContent(this.title).build());
        mainContentArea.appendChild(new ElementBuilder("h6").withClass("product-card-description").withHTMLContent(this.description).build());

        productLink.appendChild(mainContentArea);

        productLink.appendChild(new ElementBuilder("hr").withClass("product-card-price-info-seperator").build());

        const purchaseArea = new ElementBuilder("div").withClass("product-card-purchase-wrapper").build();

        const priceInfoArea = new ElementBuilder("div").withClass("product-card-price-info-wrapper").build();

        priceInfoArea.appendChild(new ElementBuilder("h2").withClass("product-card-price").withTextContent(convertUSDPriceToString(this.product.variants[0].usd_price, 0)).build());
        priceInfoArea.appendChild(new ElementBuilder("h6").withClass("product-card-what-you-get").withTextContent(`/${this.whatYouGet}`).build());

        purchaseArea.appendChild(priceInfoArea);

        const addToCartButton = new ElementBuilder("button").withClass("product-card-shopping-cart-button").withTextContent(this.cartButtonText).build();

        addToCartButton.addEventListener("mousedown", event => {

            event.preventDefault();
            
        });

        addToCartButton.addEventListener("click", event => {

            event.preventDefault();
            event.stopPropagation();

            addToCartButton.textContent = this.addingToCartMessage;

            let dotCount = 1;

            const dotAnimationInterval = setInterval(() => {

                let dotsText = "";

                for (let dots = 0; dots < dotCount; dots++) {

                    dotsText += ".";

                }

                addToCartButton.textContent = this.addingToCartMessage + dotsText;
                dotCount++;

                if (dotCount > 3) {

                    dotCount = 0;

                }

            }, this.addingToCartAnimationSpeed);

            addVariantToCart(this.variants[0].id).then((result) => {

                clearInterval(dotAnimationInterval);

                if (result === false) {

                    addToCartButton.textContent = this.failedToAddToCartMessage;

                } else {

                    addToCartButton.textContent = this.addedToCartMessage;

                }

                setTimeout(() => {

                    addToCartButton.textContent = this.cartButtonText;

                }, this.addToCartMessageDelay);

            });
            
        });

        purchaseArea.appendChild(addToCartButton);

        productLink.appendChild(purchaseArea);

        return productCard;

    }

}